var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fill-height pa-0 align-start"},[_c('v-row',{attrs:{"dense":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('navTabs')],1),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }